function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.6548 29.1034C11.7039 30.0598 9.95598 30.7139 7.78032 31.0894C6.61215 31.2911 5.42696 31.4713 4.24537 31.376C1.80446 31.179 0.116422 30.0429 1.42863 27.5863C2.39546 25.7765 3.45785 24.0185 4.60277 22.3166C5.75191 20.6086 6.98418 18.9575 8.28577 17.3638C9.59177 15.7652 10.9675 14.2239 12.4005 12.7388C12.7671 12.3589 13.1375 11.9826 13.5114 11.6098C13.9074 11.2152 14.3165 10.8303 14.7703 10.5027C15.0011 10.3361 15.2429 10.1833 15.4971 10.0553C15.7599 9.92292 16.0542 9.90986 16.3247 9.80078",
  fill: "#FC497D"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.2552 12.0915C43.9042 11.0085 47.9789 8.40122 52.0134 5.95813C54.232 4.61466 56.4612 3.27357 58.8193 2.18691C60 1.64299 61.2123 1.16282 62.4592 0.793429C63.7467 0.412083 65.05 0.228383 66.3764 0.0191809C66.4774 0.00324168 66.582 -0.0124983 66.6803 0.0149969C66.8932 0.0745697 67.0065 0.33159 66.9614 0.548363C66.8481 1.09249 65.9483 1.26443 65.5177 1.43717C65.7873 1.47005 65.9006 1.88786 65.6857 2.05462C65.5582 2.15364 65.3353 2.216 65.3658 2.3746C65.3793 2.44533 65.4445 2.49255 65.4809 2.55451C65.5545 2.67944 65.5 2.83963 65.4298 2.96654C65.1556 3.46145 64.6466 3.81889 64.0888 3.90795C62.3803 4.18111 61.2419 4.72902 59.9553 5.90932C56.3912 9.17925 52.5038 12.0953 48.3686 14.601",
  fill: "#F6B9A6"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.9461 9.79388C24.0468 9.76349 24.1477 9.73311 24.2484 9.70272C24.2681 9.69692 24.2902 9.68872 24.2977 9.66953C24.3025 9.65693 24.2993 9.64274 24.2963 9.62955C24.1571 9.04037 24.0176 8.45119 23.8783 7.86201C23.8591 7.78044 23.8358 7.69228 23.7702 7.6403C23.7232 7.60291 23.6616 7.59052 23.6026 7.57912C21.74 7.22426 19.7233 7.29163 17.8308 7.20886C17.5636 7.19727 17.2908 7.18647 17.0325 7.25784C16.567 7.38679 16.4822 7.6453 16.4165 8.10412C16.3056 8.87983 16.1415 9.64774 15.9255 10.4007",
  fill: "#FC497D"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.6168 9.41937C25.5987 9.37349 26.5792 9.33141 27.5521 9.31719C30.6817 9.27171 33.9146 9.64316 37.067 9.76757C39.6567 9.86975 42.632 10.0136 44.9199 8.60034C46.6909 10.5217 48.0108 13.3158 48.4278 15.895C45.6507 17.8392 42.3617 18.8276 39.0615 19.406C37.4412 19.6901 35.7911 19.9227 34.1488 20.0158C32.2084 20.1256 30.3216 20.4676 28.3846 20.6157C27.7013 26.5959 28.1083 32.7007 29.5794 38.5353C26.5147 40.2745 23.2597 42.0648 19.7426 42.0009C17.3957 41.9582 15.107 40.7986 12.7838 40.8577C11.3756 40.9084 9.93692 41.4119 8.5486 41.6547C8.58103 35.7296 8.9031 29.7898 9.95244 23.9793C10.4462 21.2452 10.9819 18.5024 11.8972 15.8744C12.4553 14.2718 13.0545 12.6149 14.0911 11.254C15.367 9.57885 16.8797 9.4951 18.8912 9.55681C20.7755 9.61451 22.6989 9.50932 24.6168 9.41937Z",
  fill: "#FF718D"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44.4437 8.08166C44.4525 8.02911 44.4743 7.97816 44.5116 7.92959C44.7534 7.61449 45.237 7.54801 45.5971 7.46202C46.0256 7.35951 46.4598 7.28069 46.8972 7.22635C47.1628 7.19331 47.4454 7.17181 47.6858 7.28845C47.8916 7.38818 48.0383 7.57548 48.173 7.7592C49.6422 9.76182 50.6188 12.1191 50.9943 14.5698C51.0192 14.7326 51.0406 14.9046 50.9787 15.0575C50.9147 15.2157 50.7722 15.3268 50.6358 15.4301L49.4581 16.3232C49.182 16.5326 48.7651 16.7355 48.5267 16.4847C48.4244 16.377 48.4006 16.2195 48.3796 16.0726C48.2579 15.2181 48.0631 14.373 47.7821 13.5559C47.4206 12.5045 46.9154 11.5067 46.2935 10.5837C45.9746 10.1104 45.6265 9.65693 45.2566 9.22181C45.0428 8.97021 44.3769 8.47896 44.4437 8.08166Z",
  fill: "#FC497D"
});

var SvgTorsoThumb1 = function SvgTorsoThumb1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 48,
    height: 43,
    viewBox: "0 0 67 43",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTorsoThumb1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/torso-thumb-1.7cd8a18c.svg";
export { ForwardRef as ReactComponent };